export const MAX_FEATURED_PRODUCTS = 3;

export const getFeaturedProducts = (products = []) =>
  products
    .filter((product) => product.is_featured || product.featured_order)
    .sort(
      (a, b) =>
        (a.featured_order ?? Number.MAX_SAFE_INTEGER) -
        (b.featured_order ?? Number.MAX_SAFE_INTEGER)
    )
    .slice(0, MAX_FEATURED_PRODUCTS);

export const sortFeaturedProductIds = (products = []) =>
  getFeaturedProducts(products).map((product) => product.id);

export default getFeaturedProducts;
